'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroFormDatePicker = require('./NitroFormDatePicker');

var _NitroFormDatePicker2 = _interopRequireDefault(_NitroFormDatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroFormDatePicker2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-form-date-picker/index.js
// module id = 2908
// module chunks = 4